import React, { useEffect, useState } from 'react';
import { loadConfig } from 'common/config';

export const AppConfigProvider = ({ children }: { children: React.ReactElement }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      await loadConfig();
      setIsLoading(false);
    })();
  }, []);

  return isLoading ? null : children;
};
